import { TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { capitaliseText, isNotEmpty } from "../../../helpers/StringHelpers"
import { BusinessNatureValidator } from "../../../services/validation/address-employment-form/BusinessNatureValidator"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"

const BusinessNatureField = (props: FormFieldProps<string>) => {
    const { t } = useTranslation(`signup`)
    const {
        defaultValue,
        handleChange,
        errorText,
    } = props

    const [errorMessage, setErrorMessage] = useState(``)
    const [value, setValue] = useState(defaultValue ?? ``)

    useEffect(() => {
        setValue(defaultValue ?? ``)
        setErrorMessage(errorText ?? ``)
    }, [errorText, defaultValue])

    const validateField = () => {
        const validator = new BusinessNatureValidator()
        const validationText = t(validator.validate(value) ?? ``)
        setErrorMessage(validationText)
    }

    const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        setValue(capitaliseText(event.target.value))
        handleChange(capitaliseText(event.target.value))
    }

    return (
        <TextField
            fullWidth
            error={isNotEmpty(errorMessage)}
            helperText={t(errorMessage)}
            id="business-nature"
            label={t(`business_nature`)}
            value={value}
            onChange={handleOnChange}
            onBlur={validateField}
            inputProps={{ maxLength: 66 }}
        />
    )
}

export { BusinessNatureField }